import { useTranslation } from 'react-i18next';

import Modal from '@/common/components/Modal';

interface DeleteNoteConfirmModalProps {
  isOpen: boolean;
  noteTitle?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteNoteConfirmModal = ({
  isOpen,
  noteTitle,
  onClose,
  onConfirm,
}: DeleteNoteConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} size="sm" title={t('notes.deleteConfirmTitle')} onClose={onClose}>
      <p className="text-gray-600 mb-6">
        {noteTitle
          ? t('notes.deleteConfirmMessageWithTitle', { title: noteTitle })
          : t('notes.deleteConfirmMessage')}
      </p>
      <div className="flex justify-end gap-3">
        <button
          className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          onClick={onClose}
        >
          {t('common.cancel')}
        </button>
        <button
          className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded-lg transition-colors"
          onClick={onConfirm}
        >
          {t('notes.delete')}
        </button>
      </div>
    </Modal>
  );
};
